import styled, { css } from 'styled-components';
import { BREAKPOINTS } from '@livingsecurity/shared';

export const Wrapper = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* padding: 20px 30px; */
  /* border: 1px solid #000; */

  height: ${(props) => (props.barHeight ? props.barHeight : '70px')};
  background-color: #18181B;
  color: #ffffff !important;
  position: relative;

  ${({ isSticky }) =>
    isSticky &&
    css`
      position: sticky;
      top: 0;
      z-index: 4;
    `}

  @media (max-width: ${BREAKPOINTS.TABLET}) {
    width: 100vw;
  }
`;

export const ItemsWrapper = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: ${(props) => (props.barHeight ? '0' : '0 20px 0 36px')};
  height: ${(props) => (props.barHeight ? props.barHeight : '70px')};
  color: #ffffff !important;
  position: relative;
`;

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 56px;
  margin-left: 16px;
`;

export const RightContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 56px;
`;

export const ProductName = styled.div`
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  margin: 20px 0 0 16px;
  color: var(--light-blue-grey-two);
  display: inline-block;
`;

export const ChatbotButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  color: white;
  height: 56px;
  width: 65px;
  margin: 0;
  border-left: 1px solid var(--slate-grey);
  cursor: pointer;

  &:hover {
    background: var(--dark-blue);
  }
`;

export const AdminButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  height: 36px;
  margin-right: 16px;
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme?.colors?.primary || 'var(--primary, #0070f3)'};
  border-radius: 4px;
  color: ${({ theme }) => theme?.colors?.primary || 'var(--primary, #0070f3)'};
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme?.colors?.primary || 'var(--primary, #0070f3)'};
    color: white;
  }

  i {
    margin-right: 8px;
    font-size: 16px;
  }
`;

export const HelpIconWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin-left: 12px;
`;

export const HelpLinkButton = styled.button`
  background: transparent;
  border: none;
  color: white;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  padding: 4px 0;
  text-decoration: none;
  white-space: nowrap;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }
`;

export const HelpPopoverContent = styled.div`
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  padding: 12px 16px;
  min-width: 180px;

  h4 {
    margin: 0 0 8px 0;
    font-size: 14px;
    font-weight: 500;
    color: #333;
  }

  ul {
    margin: 0;
    padding-left: 20px;
    list-style-type: disc;
  }

  li {
    margin-bottom: 4px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  a {
    color: var(--salmon, #e57373);
    text-decoration: none;
    font-size: 14px;

    &:hover {
      text-decoration: underline;
    }
  }
`;
